import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ManagerDashboard from "@/pages/ManagerDashboard";
import TechnicianApp from "@/pages/TechnicianApp";
import CollaboratorApp from "@/pages/CollaboratorApp";
import { CategoriesProvider } from "@/context/CategoriesContext";
import { Loader2 } from "lucide-react";

function RootRoute() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 text-cyan-400 animate-spin" />
      </div>
    );
  if (!user) return <Login />;
  if (user.role === "manager")
    return <CategoriesProvider><ManagerDashboard /></CategoriesProvider>;
  if (user.role === "collaborator")
    return <CategoriesProvider><CollaboratorApp /></CategoriesProvider>;
  return <CategoriesProvider><TechnicianApp /></CategoriesProvider>;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
